import "./footer.scss";
import Logo from "../../elements/SVG/LogoSvg";
import Arrow from "../../elements/SVG/ArrowSvg";
import Button from "../../elements/Button";
import { useGlobalContent } from "../../context/GlobalContext";
import { resolveLink } from "../../helpers/resolveLink";
import { GetYear } from "../../helpers/getYear";

const Footer = () => {
  const { socials, phone, email, address, openingHours } = useGlobalContent();
  const year = GetYear();

  return (
    <div className="footer">
      <div className="container-first">
        <Logo className="logo" />
        <div>
          <button
            className="button"
            rel="noreffer"
            onClick={() => {
              window.scroll({ top: 0, left: 0, behavior: "smooth" });
            }}
          >
            <Arrow className="arrow" />
          </button>
        </div>
      </div>
      {(address || openingHours) && (
        <div className="container-second">
          <div className="address-container">
            {address && <p>{address}</p>}
            {openingHours && <p>{openingHours}</p>}
          </div>
        </div>
      )}
      <div className="container-third">
        <div className="social-container">
          {socials.map((social) => {
            const { href, target } = resolveLink(social.link);
            return (
              <Button
                key={social._uid}
                link={href}
                target={target}
                label={social.title}
                noIcon
              />
            );
          })}
        </div>
        <div className="contact-container">
          {phone && <Button link={`tel:${phone}`} label={phone} noIcon />}
          {email && (
            <Button link={email} emailType="email" label={email} noIcon />
          )}
        </div>
      </div>
      <div className="container-fourth">
        <p className="rights">©{year} All Rights reserved</p>
      </div>
    </div>
  );
};
export default Footer;
